import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(20, 20, 20, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
  z-index: 10000;
`;

export const Container = styled.div`
  position: relative;
  background-color: #1e1e1e;
  width: 600px;
  padding: 32px;
  border-radius: 16px;
  border: 2px solid #ff5555;
  box-shadow: 0 0 10px rgba(255, 85, 85, 0.4), 0 0 20px rgba(255, 85, 85, 0.2),
    inset 0 0 5px rgba(255, 85, 85, 0.3);
  text-align: left;
  padding-bottom: 60px;
`;

export const Tag = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #ff5555;
  margin-bottom: 12px;
`;

export const Description = styled.div`
  font-size: 16px;
  color: #cccccc;
  padding-left: 10px;
  margin-bottom: 24px;
  white-space: pre-line;
`;

export const Button = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;

  background-color: #ff5555;
  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 15px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #ff7777;
  }
`;
